import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { useTableContext } from '../../Table.Context/index.es.js';
import { TableBodyRowProvider } from './Table.Body.Row.Context/provider.es.js';

const TableBodyRow = ({ children, className, clickable, isGroupHeader, selected, ...rest })=>{
    const [{ hoverHighlight, groupHeaderVariant }] = useTableContext();
    return jsx(TableBodyRowProvider, {
        isGroupHeader: isGroupHeader,
        children: jsx("tr", {
            className: classNames('cb-table-body-row', {
                'hover-highlight': hoverHighlight && !isGroupHeader,
                'group-header': isGroupHeader,
                [`group-header-${groupHeaderVariant}`]: isGroupHeader,
                clickable,
                selected
            }, className),
            ...rest,
            children: children
        })
    });
};
TableBodyRow.displayName = 'Table.Body.Row';

export { TableBodyRow };
//# sourceMappingURL=Table.Body.Row.es.js.map
